import { wrap } from './basler-components.es824.js';
import { isEasingArray } from './basler-components.es752.js';

function getEasingForSegment(easing, i) {
    return isEasingArray(easing) ? easing[wrap(0, easing.length, i)] : easing;
}

export { getEasingForSegment };
